<template>
  <v-dialog
    :value="dialog"
    persistent
    max-width="560"
    @input="$emit('update:dialog', $event)"
  >
    <v-card class="parchment-overwrite-dialog">
      <v-toolbar class="parchment-overwrite-dialog__toolbar" flat dark>
        <v-toolbar-title class="white--text font-weight-bold">
          {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataTitle") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="parchment-overwrite-dialog__body pt-5 pb-2 black--text">
        <p class="parchment-overwrite-dialog__question font-weight-bold mb-4">
          {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataConfirmQuestion") }}
        </p>

        <ul class="parchment-overwrite-dialog__list pl-0 mb-0">
          <li class="mb-4">
            <span class="font-weight-bold">
              {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataMismatchedTitle") }}
            </span>
            <span> {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataMismatchedDescription") }}</span>
          </li>
          <li>
            <span class="font-weight-bold">
              {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataMissingTitle") }}
            </span>
            <span> {{ $t("memberDataSection.parchmentDelivery.bulkImport.overwriteDataMissingDescription") }}</span>
          </li>
        </ul>
      </v-card-text>

      <v-card-actions class="parchment-overwrite-dialog__actions px-6 pb-5 pt-2">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          height="40"
          min-width="120"
          class="text-uppercase font-weight-bold mr-3 parchment-overwrite-dialog__cancel-btn"
          :class="{ 'parchment-overwrite-dialog__cancel-btn--kenya': isKenyaClient }"
          @click="onCancel"
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          depressed
          height="40"
          min-width="120"
          class="text-uppercase font-weight-bold white--text parchment-overwrite-dialog__confirm-btn"
          :class="{ 'parchment-overwrite-dialog__confirm-btn--kenya': isKenyaClient }"
          :color="isKenyaClient ? undefined : 'primary'"
          @click="onConfirm"
        >
          {{ $t("confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isKenyaClient } from "@/utils";

export default {
  name: "ParchmentDeliveryOverwriteConfirmDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isKenyaClient() {
      return isKenyaClient();
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancel:action");
    },
    onConfirm() {
      this.$emit("continue:action");
    },
  },
};
</script>

<style scoped lang="scss">
.parchment-overwrite-dialog__toolbar {
  background-color: #1b5e20 !important;
}

.parchment-overwrite-dialog__body {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
}

.parchment-overwrite-dialog__question {
  font-size: 14px;
  color: #212121;
}

.parchment-overwrite-dialog__list {
  list-style: none;
}

.parchment-overwrite-dialog__cancel-btn--kenya {
  border-color: #a75300 !important;
  color: #a75300 !important;
}

.parchment-overwrite-dialog__confirm-btn--kenya {
  background-color: #a75300 !important;
}
</style>
